import React, { PureComponent } from 'react';
import axios from 'axios';
import Layout from '../components/complex/layout';
import BannerCreate from './banners/bannerCreate';
import BannerEdit from './banners/bannerEdit';
import BannersList from './banners/bannersList';
import BannerView from './banners/bannerView';
import appConstant from '../../constants/app';
import HideBannerForm from './banners/hideBannerForm';
import DeleteBannerForm from './banners/deleteBannerForm';
import ModalComponent from '../components/complex/modalComponent';

class Banners extends PureComponent {
  state = {
    banners: [],
    isBannersList: true,
    bannerView: 1,
    bannerDetail: {},
    isActive: false,
    title: '',
    body: '',
    bannerId: null,
  }

  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  createBanner = () => {
    this.setState({bannerView: 2})
  }

  componentDidMount() {
    this.fetchBanners();
  }

  fetchBanners = () => {
    let url = `${appConstant.API_URL}/banner?access_token=${localStorage.getItem('token')}`;
    axios.get(url)
      .then(res => {
        const banners = res.data.banners;
        this.setState({banners});
      }).catch(err => {
        console.log(err);
      });
  }

  onCancel = () => {
    this.setState({ bannerView: 1 });
    this.fetchBanners();
  }

  onViewHandle = (bannerId) => {
    let url = `${appConstant.API_URL}/banner/show/${bannerId}?access_token=${localStorage.getItem('token')}`;
    axios.get(url)
      .then(res => {
        const bannerDetail = res.data.banner;
        this.setState({
          bannerView: 3,
          bannerDetail,
        });
      }).catch(err => {
        console.log(err);
      });
  }

  onHideHandle = (id, hidden, label) => {
    this.onToggleModal();

    this.setState({
      body: <HideBannerForm
        bannerId={id}
        label={label}
        hidden={hidden}
        onClose={this.onToggleModal}
        onAccept={this.fetchBanners}
      />,
      title: `Are you sure you want to ${hidden === 0 ? 'hide' : 'show' } ${label}?`,
    });
  }

  onDeleteHandle = (id, label) => {
    this.onToggleModal();

    this.setState({
      body: <DeleteBannerForm
        bannerId={id}
        label={label}
        onClose={this.onToggleModal}
        onAccept={this.fetchBanners}
      />,
      title: `Are you sure you want to delete ${label}?`,
    });
  }

  onEditHandle = (id) => {
    this.setState({
      bannerId: id,
      bannerView: 4,
    });
  }

  renderElement = () => {
    const {
      banners,
      bannerView,
      bannerDetail,
      bannerId,
    } = this.state;

    if(bannerView === 1) {
      return <BannersList
        list={banners}
        createBanner={this.createBanner}
        viewHandle={this.onViewHandle}
        hideHandle={this.onHideHandle}
        editHandle={this.onEditHandle}
        deleteHandle={this.onDeleteHandle}
      /> ;
    } else if (bannerView === 2) {
      return <BannerCreate
        cancel={this.onCancel}
      /> ;
    } else if (bannerView === 3) {
      return <BannerView
        data={bannerDetail}
        back={this.onCancel}
      />
    } else if (bannerView === 4) {
      return <BannerEdit
        id={bannerId}
        cancel={this.onCancel}
      /> ;
    }

    return null;
  }

  render() {
    const {
      body,
      title,
      isActive,
    } = this.state;

    return (
      <Layout>
        { this.renderElement() }
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title={title}
          body={body}
        />
      </Layout>
    );
  }
}

export default Banners;


// WEBPACK FOOTER //
// ./src/app/screens/banners.js